import React from 'react';
import { Button } from '@ui';
import { translate } from '@utils/i18n';
import { useUpdateKitOrderStatusMutation } from '../hooks/useUpdateKitOrderStatusMutation';
import { KIT_ORDERS_NAMESPACE, KIT_ORDER_STATUS } from '../constants';
export default function KitOrderStatusActionCell({ tdProps, dataItem }) {
    const mutation = useUpdateKitOrderStatusMutation();
    const isPending = dataItem.status === KIT_ORDER_STATUS.PENDING;
    const nextStatus = isPending ? KIT_ORDER_STATUS.COMPLETED : KIT_ORDER_STATUS.PENDING;
    const buttonText = isPending
        ? translate('kit_orders.actions.mark_as_received', {
            namespace: KIT_ORDERS_NAMESPACE,
            defaultValue: 'Mark as Received'
        })
        : translate('kit_orders.actions.mark_as_sent', {
            namespace: KIT_ORDERS_NAMESPACE,
            defaultValue: 'Mark as Sent'
        });
    const buttonIcon = isPending ? 'fa-check' : 'fa-rotate-right';
    const handleToggle = () => {
        mutation.mutate({ id: dataItem.id, status: nextStatus });
    };
    return (React.createElement("td", Object.assign({}, tdProps),
        React.createElement(Button, { onClick: handleToggle, disabled: mutation.isLoading, variant: "default" }, mutation.isLoading ? (React.createElement(React.Fragment, null,
            React.createElement("i", { className: "fa-light fa-spinner-third fa-spin" }),
            buttonText)) : (React.createElement(React.Fragment, null,
            React.createElement("i", { className: `fa-light ${buttonIcon}` }),
            buttonText)))));
}
